import { Eye } from 'lucide-react'
import { PreviewOverlay } from '@/tools/preview/PreviewOverlay'
import { ToolKind, UtilityId, type UtilityTool } from '@/tools/types'

export const PREVIEW_TOOL = {
  id: UtilityId.Preview,
  kind: ToolKind.Utility,
  label: 'Preview',
  icon: Eye,
  Overlay: PreviewOverlay,
} satisfies UtilityTool
